import React from "react";
import IntlMessages from "../../helpers/IntlMessages";

const NameRoomAndMainCourseInfo = ({ res, request, alacarteRequestTimeSlot }) => {

  return (
    <div className="d-table">
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.name" />
        </div>
        <div className="w-58 float-right">{res.name}</div>
      </div>
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.room_number" />
        </div>
        <div className="w-58 float-right">
          {res.room_number || res.room ? (
            res.room_number || res.room
          ) : (
            <IntlMessages id="bookingDetails.room_info" />
          )}
        </div>
      </div>
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.main_course" />
        </div>
        <div className="w-58 float-right">{res.main_course_name}</div>
      </div>
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.restaurants_header" />
        </div>
        <div className="w-58 float-right">
          {JSON.parse(request.custom_fields_values[0].value).restaurant_name}
        </div>
      </div>
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.time" />
        </div>
        <div className="w-58 float-right">
          {alacarteRequestTimeSlot}
        </div>
      </div>
      <div className="d-table-row mb-1">
        <div className="text-muted float-left w-40">
          <IntlMessages id="alacarte.date" />
        </div>
        <div className="w-58 float-right">
          {JSON.parse(request.custom_fields_values[0].value).restaurant_time_slot
            ? `${JSON.parse(request.custom_fields_values[0].value).restaurant_time_slot}`
            : `${request.due_at_date}`}
        </div>
      </div>
      {!!res.notes && (
        <div className="d-table-row mb-1">
          <div className="text-muted float-left w-40">
            <IntlMessages id="alacarte.notes" />
          </div>
          <div className="w-58 float-right">{res.notes}</div>
        </div>
      )}
    </div>
  );
};

export default NameRoomAndMainCourseInfo;
